import * as z from "zod";

export const DatePeriodDeserializer = z.object({
  from: z
    .string()
    .datetime()
    .transform((d) => new Date(d)),
  to: z
    .string()
    .datetime()
    .transform((d) => new Date(d)),
});
